import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import NavBarAuth from "../../../../components/navbar/navbarAuth";
import { BaseURL } from "../../../../Files/BaseURL";
import AlertContext from "../../../../Context/Alert/AlertContext";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setIsLoading] = useState(false);
  const alertContext = useContext(AlertContext);
  const { showAlert } = alertContext;
  const navigate = useNavigate();

  const [errors, setErrors] = useState({
    email: "",
  });

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email) {
      return "Email is required";
    }
    if (!emailRegex.test(email)) {
      return "Please enter a valid email address";
    }
    return "";
  };

  const handleForgotPassword = async () => {
    const emailError = validateEmail(email);
    setErrors({ email: emailError });

    if (emailError) {
      return;
    }

    setIsLoading(true);

    try {
      const response = await fetch(`${BaseURL}/api/authlogin/forgot-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
        credentials: "include",
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          data.message || `HTTP error! status: ${response.status}`
        );
      }

      if (data.success) {
        sessionStorage.setItem("forgot_email", email);
        if (data.token) {
          sessionStorage.setItem("forgot_token", data.token);
        }

        showAlert(data.message || "OTP sent to your email", "success");
        navigate("/reset_password", {
          state: {
            email: email,
            type: "forgot",
          },
        });
      } else {
        showAlert(data.message || "Failed to send reset email", "error");
      }
    } catch (error) {
      console.error("Forgot password error:", error);
      showAlert(
        error.message ||
          "Unable to process your request. Please try again later.",
        "error"
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <NavBarAuth />
      <div className="flex justify-center items-center bg-gray-100 py-20">
        <div className="mx-6 bg-white p-8 rounded-lg shadow-md">
          <h2 className="text-2xl font-bold mb-4">Forgot Password?</h2>
          <p className="text-gray-600 mb-6 max-w-sm">
            Don't worry, happens to all of us. Enter your email below to recover
            your password
          </p>

          <div className="mb-4">
            <input
              type="email"
              id="email"
              name="email"
              placeholder="Email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setErrors((prev) => ({ ...prev, email: "" }));
              }}
              className={`w-full px-6 border-2 ${
                errors.email ? "border-red-500" : "border-transparent"
              } font-pop text-lg rounded-full bg-[#E8E8E8] py-2 focus:border-primarygreen focus:outline-none`}
            />
            {errors.email && (
              <p className="text-red-500 text-sm mt-1 ml-4">{errors.email}</p>
            )}
          </div>

          <button
            onClick={handleForgotPassword}
            disabled={loading}
            className="my-4 w-full bg-green-500 hover:bg-transparent hover:bg-white-500 font-semibold hover:text-black font-pop text-xl py-3 px-4 border border-black-500 hover:border-green-500 rounded-full text-white animate__animated animate__backInUp disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? (
              <div className="flex items-center justify-center">
                <div className="w-6 h-6 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
              </div>
            ) : (
              "Reset Password"
            )}
          </button>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
